import type { Scene } from '../../types';
import { deepClone, uniqueId } from './utils';

/** Deep-clone a scene and assign fresh ids (including nested branch scenes). */
export function cloneSceneWithNewIds(scene: Scene): Scene {
  const cloned = deepClone(scene);
  return assignNewSceneIds(cloned);
}

function assignNewSceneIds(scene: Scene): Scene {
  const next = { ...scene, id: uniqueId('scene') } as Scene;
  if (next.type === 'choice') {
    next.options = next.options.map((opt) => ({
      ...opt,
      scenes: opt.scenes?.map((s) => assignNewSceneIds(s)),
    }));
  }
  return next;
}

/** Prepare a scene body ready for insertion (new ids assigned). */
export function sceneToPasteBody(scene: Scene): Omit<Scene, 'id'> {
  const cloned = cloneSceneWithNewIds(scene);
  const { id: _id, ...body } = cloned;
  return body as Omit<Scene, 'id'>;
}
